import { Component, OnInit } from '@angular/core';
import { Company } from '../../../../models/company';
import { CompanyService } from '../../../../services/company.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../../services/auth.service';
import { WebUserService } from '../../../../services/web-user.service';
import { WebUser } from '../../../../models/web_User';
import { WebUserType } from '../../../../models/web_User_Type';

@Component({
  selector: 'app-web-user-manage',
  templateUrl: './web-user-manage.component.html',
  styleUrls: ['./web-user-manage.component.css']
})
export class WebUserManageComponent implements OnInit {
  companies: Company[];
  webUser: WebUser;
  webUserTypes: WebUserType[];
  client;

  onlyPassword = false;

  constructor(private companyService: CompanyService, private authService: AuthService, private webUserService: WebUserService,
    private router: Router, private route: ActivatedRoute) {
    this.client = authService.currentUser.value;
    this.webUser = new WebUser();
  }

  ngOnInit() {
    this.companyService.getAll(0).then((companyData) => {
      this.companies = companyData;
      this.webUserService.getAllUserTypes().then((userTypeData) => {
        this.webUserTypes = userTypeData;
        console.log(this.webUserTypes);
        console.log(this.webUserTypes);

        this.route.queryParams.subscribe(params => {
          let user_Id = params['user_Id'];

          if (user_Id == undefined && user_Id != 'new') {
            this.onlyPassword = true;
            user_Id = this.client.userId;
          }

          if (user_Id != undefined && user_Id != 'new') {
            this.webUserService.get(user_Id).then((data) => {
              this.webUser = data;
              this.webUser.confirmEmail = this.webUser.email;
              this.webUser.is_edit = true;
            });
          }

        });

      });
    });
  }

  submit() {
    this.webUserService.save(this.webUser).then((data) => {
      if (data.success) {
        if (this.onlyPassword) {
          this.refreshSession();
        } else {
          this.router.navigate(['users/web_management']);
        }
      }
    });
  }
  
  refreshSession() {
    this.authService.login(this.webUser.email, this.webUser.password, false).then((res) => {
      if (res) {
        this.router.navigate(['/home']); 
      } else {
        this.authService.logout();
        this.router.navigate(['/login']);
      }
    });
  }


}
